"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const PREFIX = "Carousel";
exports.classes = {
    showOffScreen: `${PREFIX}-wrapperShowOffScreen`,
    gutter: `${PREFIX}-wrapperGutter`,
    opacity: `${PREFIX}-opacity`,
    swipeable: `${PREFIX}-swipeable`,
    carouselGutter: `${PREFIX}-carouselGutter`,
    page: `${PREFIX}-page`,
    slide: `${PREFIX}-slide`,
    swipeableSlide: `${PREFIX}-swipeableSlide`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    height: "100%",
    position: "relative",
    [`&.${exports.classes.gutter}`]: {
        margin: "0 -8px",
        [theme.breakpoints.up("md")]: {
            margin: "0 -12px"
        }
    },
    [`&.${exports.classes.showOffScreen}`]: {
        [`& .${exports.classes.page}`]: {
            justifyContent: "flex-start"
        },
        [`& .${exports.classes.swipeableSlide}`]: {
            '&[aria-hidden="true"]': {
                opacity: "0.35 !important",
                visibility: "visible"
            }
        },
        // NOTE: 16px is the grid gutter
        margin: "0 calc(16px / 2 + 30px)",
        [theme.breakpoints.up("md")]: {
            // NOTE: 16px is the grid gutter
            margin: "0 calc(24px / 2 + 50px)"
        },
        [theme.breakpoints.up("xl")]: {
            margin: 0
        }
    }
}));
exports.Wrapper = (0, styles_1.styled)("div")(({ theme }) => ({
    [theme.breakpoints.up("md")]: {
        position: "relative",
        flex: 1,
        height: "100%",
        "& > div": {
            height: "100%"
        },
        "& .react-swipeable-view-container": {
            height: "100%"
        }
    },
    [`& .${exports.classes.swipeableSlide}`]: {
        '&[aria-hidden="true"]': {
            visibility: "hidden"
        },
        '&[aria-hidden="false"]': {
            visibility: "visible"
        }
    },
    [`&.${exports.classes.opacity}`]: {
        "& > div": {
            overflowX: "visible !important"
        },
        [`& .${exports.classes.swipeableSlide}`]: {
            overflow: "revert !important",
            transition: "0.3s ease-in-out opacity",
            '&[aria-hidden="false"]': {
                opacity: 1
            },
            '&[aria-hidden="true"]': {
                opacity: 0,
                pointerEvents: "none"
            }
        }
    },
    [`&.${exports.classes.swipeable}`]: {
        [`& .${exports.classes.page}`]: {
            "&:hover": {
                cursor: "grab"
            },
            "&:active": {
                cursor: "grabbing",
                userSelect: "none"
            }
        }
    },
    [`&.${exports.classes.carouselGutter}`]: {
        [`& .${exports.classes.slide}`]: {
            padding: "0 8px",
            [theme.breakpoints.up("md")]: {
                padding: "0 12px"
            }
        }
    },
    [`& .${exports.classes.page}`]: {
        display: "flex",
        width: "100%",
        height: "100%",
        justifyContent: "center"
    },
    [`& .${exports.classes.slide}`]: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%"
    }
}));
//# sourceMappingURL=data:application/json;base64,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